import { isBefore, isAfter } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { i18n } from '@/main.js'; // Ensure correct import path

const timeZone = 'America/Los_Angeles';

// Function to fetch dates dynamically from i18n
const getLocalizedDate = (key) => {
  const dateString = i18n.global.t(key); // Fetch localized date string
  return new Date(dateString); // Convert to Date object
};

const setTimeForDate = (date, hours, minutes, seconds) => {
  const newDate = new Date(date);
  newDate.setHours(hours, minutes, seconds);
  return newDate;
};

const formatDate = (date) => formatInTimeZone(date, timeZone, 'MM/dd/yyyy');

const routeGuard = (to, from, next) => {
  const now = new Date();
  
  const startDate = getLocalizedDate('program.startDate');
  const endDate = getLocalizedDate('program.endDate');

  const startDateWithTime = setTimeForDate(startDate, 0, 0, 0);
  const endDateWithTime = setTimeForDate(endDate, 23, 59, 59);

  const currentDate = formatDate(now);
  const startDatePT = formatDate(startDateWithTime);
  const endDatePT = formatDate(endDateWithTime);

  if (isBefore(currentDate, startDatePT)) {
    return to.name !== 'PreProgram' ? next({ name: 'PreProgram' }) : next();
  } else if (isAfter(currentDate, endDatePT)) {
    return to.name !== 'PostProgram' ? next({ name: 'PostProgram' }) : next();
  } else {
    return to.name === 'PreProgram' ? next({ name: 'Home' }) : next();
  }
};

export { routeGuard };
